import React, { useRef } from "react";
import { Container } from "./container";

interface RecommendationCard {
  id: number;
  image: string;
  title: string;
  subtitle: string;
  recommendedBy: string;
}

const RECOMMENDATIONS: RecommendationCard[] = [
  {
    id: 1,
    image: "curated-experiences/recommendations/slide-1.png",
    title: "Recommended by Selena",
    subtitle: "Society Salon",
    recommendedBy: "Selena",
  },
  {
    id: 2,
    image: "/curated-experiences/recommendations/slide-2.png",
    title: "Recommended by the Utah Jazz",
    subtitle: "Cafe Document",
    recommendedBy: "the Utah Jazz",
  },
  {
    id: 3,
    image: "/curated-experiences/recommendations/slide-3.png",
    title: "Recommended by Jennifer",
    subtitle: "Equinox",
    recommendedBy: "Jennifer",
  },
  {
    id: 4,
    image: "/curated-experiences/recommendations/slide-4.png",
    title: "Recommended by James",
    subtitle: "Horizon Child Development Centre",
    recommendedBy: "James",
  },
  {
    id: 5,
    image: "/curated-experiences/recommendations/slide-5.png",
    title: "Recommended by Michelle",
    subtitle: "Med 44 Arcadia",
    recommendedBy: "Michelle",
  },
];

function Recommendations() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="bg-white">
      <div
        ref={scrollContainerRef}
        className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-4"
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {RECOMMENDATIONS.map((rec, index) => (
          <div
            key={rec.id}
            className="flex-shrink-0 snap-start w-[70vw] md:w-[342.8px]"
          >
            <div className="h-[388.1px] overflow-hidden">
              <img
                src={rec.image}
                alt={rec.title}
                className={`w-full h-full object-cover ${
                  index === 1 ? "object-top" : "object-center"
                }`}
              />
            </div>
            <div className="p-4 bg-white">
              <h3 className="font-bold text-lg mb-1">{rec.title}</h3>
              <p className="text-gray-600 text-sm">{rec.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] mt-7 md:mt-16 lg:mt-40 gap-5 lg:gap-32">
          <h2
            className="font-ppacma text-[56px] md:text-8xl leading-[90%] break-words hyphens-auto"
            lang="de"
          >
            <span className="text-black">Recommendations</span>{" "}
            <span className="text-yellow">You Can Trust</span>
          </h2>

          <p className="text-[#3E3E3E] text-[18px] font-normal leading-[120%] tracking-[0px] mt-[24px] mb-7 self-end max-w-[462px]">
            League Life surfaces providers, services, and resources that
            families can rely on: from schools and healthcare to trainers and
            advisors. Every recommendation is thoughtfully vetted and shared
            with the community so you can navigate life with confidence.
          </p>
        </div>
      </Container>
    </div>
  );
}

export { Recommendations };
